import { render, staticRenderFns } from "./AnswersReportIntents.vue?vue&type=template&id=6bc314db&"
import script from "./AnswersReportIntents.vue?vue&type=script&lang=js&"
export * from "./AnswersReportIntents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports